import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export const MyDataCard = () => {
  const [s, setS] = useState(null);
  const [key, setKey] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/mydata/settings").then(({ data }) => setS(data));
  }, []);

  if (!s) return null;

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/mydata/settings", {
        enabled: s.enabled,
        environment: s.environment,
        aade_user_id: s.aade_user_id,
        subscription_key: key || null,
      });
      setS(data);
      setKey("");
      toast.success("Οι ρυθμίσεις myDATA αποθηκεύτηκαν");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Σφάλμα αποθήκευσης");
    }
    setSaving(false);
  };

  return (
    <Card className="rounded-sm border-border shadow-none" data-testid="mydata-card">
      <div className="border-b border-border px-6 py-4">
        <h3 className="font-head font-bold">Διασύνδεση myDATA (ΑΑΔΕ)</h3>
        <p className="mt-1 text-xs text-muted-foreground">
          Κάθε τιμολόγιο/απόδειξη που εκδίδεται αποστέλλεται αυτόματα στο myDATA. Τα διαπιστευτήρια εκδίδονται από το mydata.aade.gr για το Α.Φ.Μ. της επιχείρησής σας.
        </p>
      </div>
      <div className="grid gap-4 p-6 sm:grid-cols-2">
        <div className="flex items-center justify-between rounded-sm border border-border px-4 py-3 sm:col-span-2">
          <div>
            <div className="text-sm font-medium">Ενεργή αποστολή στο myDATA</div>
            <div className="text-xs text-muted-foreground">Αν είναι ανενεργή, τα παραστατικά εκδίδονται μόνο τοπικά σε PDF.</div>
          </div>
          <Switch checked={s.enabled} onCheckedChange={(v) => setS({ ...s, enabled: v })} data-testid="mydata-enabled-switch" />
        </div>
        <div>
          <Label className="text-xs text-muted-foreground">Περιβάλλον</Label>
          <Select value={s.environment} onValueChange={(v) => setS({ ...s, environment: v })}>
            <SelectTrigger className="mt-1 rounded-sm" data-testid="mydata-env-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="test">Δοκιμαστικό (sandbox ΑΑΔΕ)</SelectItem>
              <SelectItem value="production">Παραγωγή</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs text-muted-foreground">Όνομα χρήστη ΑΑΔΕ (aade-user-id)</Label>
          <Input value={s.aade_user_id} onChange={(e) => setS({ ...s, aade_user_id: e.target.value })} className="mt-1 rounded-sm" data-testid="mydata-userid-input" />
        </div>
        <div className="sm:col-span-2">
          <Label className="text-xs text-muted-foreground">Subscription Key</Label>
          <Input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder={s.key_set ? `αποθηκευμένο (${s.key_masked})` : "επικολλήστε το κλειδί"} className="mt-1 rounded-sm" data-testid="mydata-key-input" />
        </div>
        <div className="sm:col-span-2">
          <Button className="rounded-sm bg-[#0055FF] hover:bg-[#0044CC]" disabled={saving} onClick={save} data-testid="mydata-save-btn">
            Αποθήκευση
          </Button>
        </div>
      </div>
    </Card>
  );
};
